import React from 'react';
import logo from './logo.svg';

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { Layout } from './components/Layout';
import { Agenda } from './pages/Agenda';
import { Calendar } from './pages/Calendar';
import { Rooms } from './pages/Rooms';
import { ModuleOverview } from './pages/ModuleOverview';

import './App.css';

function MyRoutes() {
  return (
    <BrowserRouter basename={'/Apps/Tickler'}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Agenda />} />
          <Route path="/agenda" element={<Agenda />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/rooms" element={<Rooms />} />
          <Route path="/ModuleOverview" element={<ModuleOverview />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}



function App() {
  return (
    <MyRoutes />
  );
}

export default App;
